import { useState } from "react";

export const useLazyChildRenderer = isOpen => { 
  const [shouldRenderContent, setContentRendered] = useState(false);

  if(!shouldRenderContent && isOpen){
    setContentRendered(true);
  }

  return shouldRenderContent;
};